exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sticky-top { \n  top: 80px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/xampp_bk/htdocs/xampp/organicshop/src/app/shopping/components/products/product-filter/product-filter.component.css
// module id = ../../../../../src/app/shopping/components/products/product-filter/product-filter.component.css
// module chunks = 1